var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"top":"20px","visible":_vm.dialogVisible,"title":"编辑规范","width":"1400px"},on:{"open":_vm.open,"close":_vm.close}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://files.mankoo.cn/group1/M00/BB/7B/rBGknWP3Gk2ARI6QACJpndIz7HQ212.png","alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9907720a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/report-course-dialog.vue
// module id = null
// module chunks = 